module.exports = __webpack_public_path__ + "static/media/sn.5b654e1a.svg";